import { createSportConfig } from '../createSportConfig';
import { FootballIcon } from '../../icons/FootballIcon';

const footballConfig = createSportConfig({
    type: 'football',

    selection: {
        noun: 'team',
        nounPlural: 'teams',
        nounPossessive: "team's",
        nounCapitalized: 'Team'
    },

    event: {
        noun: 'match',
        nounPlural: 'matches',
        actionNoun: 'game'
    },

    icons: {
        sportIcon: '⚽',
        SportIconComponent: FootballIcon
    },

    assets: {
        bannerImage: '/img/default-football.jpg',
        defaultSelectionIcon: '/img/default-crest.svg'
    },

    features: {
        hasUpcomingRounds: false,
        hasPlayItvCta: true
    },

    mapSelectionToCardProps: selection => ({
        teamName: selection.name || '-',
        badge: (selection.metaData && selection.metaData.silk) || undefined
    })
});

export const footballPlayerConfig = createSportConfig({
    type: 'football',

    selection: {
        noun: 'player',
        nounPlural: 'players',
        nounPossessive: "player's",
        nounCapitalized: 'Player'
    },

    event: {
        noun: 'match',
        nounPlural: 'matches',
        actionNoun: 'game'
    },

    icons: {
        sportIcon: '⚽',
        SportIconComponent: FootballIcon
    },

    assets: {
        bannerImage: '/img/default-football.jpg',
        defaultSelectionIcon: '/img/default-crest.svg'
    },

    features: {
        hasUpcomingRounds: false,
        hasPlayItvCta: true
    },

    mapSelectionToCardProps: selection => ({
        teamName: selection.name || '-',
        badge: (selection.metaData && selection.metaData.silk) || undefined
    }),

    labelOverrides: {
        winCondition: (eventTime, eventName, eventNoun) =>
            `is the last player to receive a card in the ${eventTime} ${eventName} ${eventNoun}, including Extra-Time & Penalties,`
    }
});

export default footballConfig;
